module.exports = __webpack_public_path__ + "img/optik.ec03374f.svg";